export default {
  message: { //菲律宾
    "strid1": "Mag log in",
    "strid2": "Pagpapahayag",
    "strid3": "Dagdag pa",
    "strid4": "Pagtatanong sa parusa",
    "strid5": "Iulat ang pagtatanong",
    "strid6": "Anunsyo ng parusa",
    "strid7": "Security Science",
    "strid8": "Mga panuntunan sa parusa",
    "strid9": "Oras ng pag-uulat",
    "strid10": "Iulat ang manlalaro",
    "strid11": "Iulat ang dahilan",
    "strid12": "Resulta ng ulat",
    "strid13": "Tinanggap",
    "strid14": "Paglabag",
    "strid15": "Oras ng parusa",
    "strid16": "Dahilan sa parusa",
    "strid17": "Unbanning oras",
    "strid18": "Apela",
    "strid19": "Naapela",
    "strid20": "Pagpapatunay",
    "strid21": "Nabigo ang apela",
    "strid22": "Resulta ng apela",
    "strid23": "Matagumpay ang apela",
    "strid24": "maagap",
    "strid25": "Form ng apela",
    "strid26": "Mga posibleng dahilan para sa parusa",
    "strid27": "Video / larawan / plug-in na address ng pag-download ng software",
    "strid28": "Paglalarawan",
    "strid29": "self-service system",
    "strid30": "Mga palayaw",
    "strid31": "Account ID",
    "strid32": "Antas",
    "strid33": "Ranggo",
    "strid34": "Tagal Ng Laro",
    "strid35": "Modelo ng telepono",
    "strid36": "Mailbox",
    "strid37": "Binding AccountID （google ， fb or vk）",
    "strid38": "Bago mag-apela, kailangan mong punan ang impormasyon ng iyong account at impormasyon sa pakikipag-ugnay upang maaari kaming makipag-ugnay sa iyo",
    "strid39": "Ninakaw ang aking account.",
    "strid40": "Hindi ako nag cheat, account ko lang ang ginamit ko.",
    "strid41": "Inaamin kong nandaya ako at hindi ko na ito uulitin.",
    "strid42": "Pasok ",
    "strid43": "Tawagan ang Customer Service",
    "strid44": 'alam ko',
    "strid45": 'Hindi',
    "strid46": 'Mangyaring kumpletuhin ang form',
  }
}

